import React, { useContext, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';

import { firebaseInitialize, firebaseConfig } from 'config/firebase/client';

import Loading from 'components/Loading/Loading';

import AuthenticationContext from 'context/Authentication/AuthenticationContext';

const PrivateRouteRoleCountry = ({ component: Component, ...rest }) => {

    const { getAuthenticated, authenticatedState } = useContext(AuthenticationContext);

    useEffect(() => {
        firebaseInitialize(firebaseConfig);

        async function getUserAuthenticated() {
            await getAuthenticated();
        }
        getUserAuthenticated();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

  return (
    <Route {...rest} render={
      props => {
        if (authenticatedState.isLogged) {
            if (authenticatedState.user.role === 'AdministradorPais' || authenticatedState.user.role === 'OperadorPais') {
              return <Component {...rest} {...props} />
            } else {
              return <Redirect to={
                {
                  pathname: '/admin/dashboard',
                  state: {
                    from: props.location
                  }
                }
              } />
            }
        } else if (authenticatedState.isLogged === null) {
          return <Loading spinner="spinner-border-primary" height="100vh" />
        } else {
          return <Redirect to={
            {
              pathname: '/admin/dashboard/account/login',
              state: {
                from: props.location
              }
            }
          } />
        }
      }
    } />
  )
}

export default PrivateRouteRoleCountry;